<template>
  <TIcon
    name="loader"
    size="48"
    class="origin-center animate-spin justify-center"
    :class="{
      'text-primary-foreground': variant === 'primary',
      'text-neutral-700': variant === 'neutral',
    }"
  />
</template>
<script lang="ts" setup>
import TIcon from './Icon/TIcon.vue';
withDefaults(defineProps<{ variant?: 'primary' | 'neutral' }>(), {
  variant: 'primary',
});
</script>
